import { Vue } from "vue-ext";
// import "../../components";
// TODO: Only import required components from root components
Vue.mixin({
    components: {
        // KkCountrySelect: require("./KkCountrySelect").default,
        // KkCustomerAddressSelect: require("./KkCustomerAddressSelect").default,
        // KkDatepicker: require("./KkDatepicker").default,
        // KkDatepicker2: require("./KkDatepicker2").default,
        // KkLoadingBar: require("./KkLoadingBar").default,
        // KkLoadingDialog: require("./KkLoadingDialog").default,
        // KkModalDialog: require("./KkModalDialog").default,
        // KkPager: require("./KkPager").default,
        // KkSelect: require("./KkSelect").default,
        // KkSelect2: require("./KkSelect2").default,
        // KkSelect3: require("./KkSelect3").default,
        // KkSelect4: require("./KkSelect4").default,
        KkCheckbox: require("../../components/KkCheckbox").default,
        KkTextarea: require("../../components/KkTextarea").default,
        KkTextField: require("../../components/KkTextField").default,
    }
});
